var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVirtualIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2151_979)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.5 0C1.84315 0 0.5 1.34315 0.5 3V15C0.5 16.6569 1.84315 18 3.5 18H15.5C17.1569 18 18.5 16.6569 18.5 15V3C18.5 1.34315 17.1569 0 15.5 0H3.5ZM11.5 6C11.5 7.10457 10.6046 8 9.5 8C8.39543 8 7.5 7.10457 7.5 6C7.5 4.89543 8.39543 4 9.5 4C10.6046 4 11.5 4.89543 11.5 6ZM5.5 11.5C5.5 10.6716 6.17157 10 7 10H12C12.8284 10 13.5 10.6716 13.5 11.5C13.5 12.3284 12.8284 13 12 13H7C6.17157 13 5.5 12.3284 5.5 11.5Z",
    fill: "#641793"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2151_979"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVirtualIcon);
export default __webpack_public_path__ + "static/media/virtual_icon.746c46f2579b1a2320c55bc75845d881.svg";
export { ForwardRef as ReactComponent };